import compose from 'react-hooks-compose'

import { useNewFormContribuicaoLogic } from './useNewFormContribuicao'
import { NewFormContribuicaoPresenter } from './presenter'

export const NewFormContribuicao = compose(props => ({
	useLogic: () => useNewFormContribuicaoLogic(props),
}))(NewFormContribuicaoPresenter)
